<template>
  <div>
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group id="registerNameGroup"
                    label=""
                    label-for="registerName">
        <b-form-input id="registerName"
                      type="text"
                      v-model="form.name"
                      required
                      placeholder="Enter your full name">
        </b-form-input>
      </b-form-group>
      <b-form-group id="RegisterMailGroup"
                    label=""
                    label-for="registerMail">
        <b-form-input id="registerMail"
                      type="email"
                      v-model.trim="form.email"
                      required
                      placeholder="Enter your@email.com">
        </b-form-input>
      </b-form-group>
      <b-form-group id="RegisterPasswordGroup"
                    label=""
                    label-for="registerPassword">
        <b-form-input id="RegisterPassword"
                      type="password"
                      v-model="form.password"
                      required
                      :state="passwordState"
                      aria-describedby="RegisterPassword RegisterPasswordFeedback"
                      minlength="6"
                      placeholder="*******">
        </b-form-input>
            <b-form-text id="RegisterPasswordFeedback">
      <!-- This will only be shown if the preceeding input has an invalid state -->
      Create a Password, 6 or more characters
    </b-form-text>
 </b-form-group>
      <b-form-group id="termsGroup">
              <b-form-checkbox id="termsCheckbox"
                     v-model="form.terms"
                     value="accepted"
                     unchecked-value="not_accepted"
                     class="text-muted"
                     required>
                    I accept the <a href="https://www.capprize.com/rules/" target="_blank">terms of entry</a>
                </b-form-checkbox>
    
      </b-form-group>
     
      <b-button type="submit" variant="primary" class="mr-2">Register</b-button>
      <b-button :to="{name:'sign-in'}" variant="outline-primary" class="mr-2">Sign-in</b-button>
      <b-button :to="{name:'reminder'}" variant="link" class="mr-2">Password Reset</b-button>
    </b-form>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      form: {
        email: '',
        name: '',
        password: '',
        terms: 'not_accepted'
      },
      show: true
    }
  },
  computed: {
    passwordState() {
      return this.form.password.length > 2 ? true : null
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      // alert(JSON.stringify(this.form))
      this.$store.dispatch('auth/register', this.form)
    }
  }
}
</script>

<!-- b-form-1.vue -->

<style scoped>
</style>
